// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"2241":"main-c92480b7","8659":"main-9a8b795a"}[chunkId] || chunkId) + ".css";
};